/*

GLOBAL SCRIPTS	
	
These functions make sure WordPress
and Foundation play nice together.
*/
//(function($){})(jQuery);

var window = jQuery(window);
jQuery(document).ready(function($) {	
	//initDebugin();
	initJsGlobal();
	initOffCanvasSwitcher();		
	initNavigation();
	initParallax();		
	initMobileExpandr();
	initGalleries();		
	initGravityFormsStyles();	
	initHellobar();
	initBrowserExposure();
	initMenuStyle();
});

var Swiper;
var Foundation;
// used to console log screen breakpoint changes while developing themes
function initDebugin() {
	var currentBreakpoint = Foundation.MediaQuery.current;
	//console.log('the current breakpoint is ' + currentBreakpoint);
	jQuery(window).on('changed.zf.mediaquery', function(event, newSize, oldSize) {
		  // newSize is the name of the now-current breakpoint, oldSize is the previous breakpoint
	});
	
	jQuery(document).on('show.zf.dropdownMenu', function(ev, $el) {
   	 	console.log('dropdown has been opened');
	});
}

function initJsGlobal() {
	// Remove empty P tags created by WP inside of Accordion and Orbit
    jQuery('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
		  jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
		  jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});

	jQuery('.main .grid-x-wrapper, .sidebar .grid-x-wrapper').removeClass('grid-x-wrapper').find('.gform_body .gform_fields').addClass("grid-x grid-padding-x");
	jQuery('.main .gfield.hidden_label .gfield_label, .sidebar .grid-x-wrapper').remove();
		
	jQuery(document).on('gform_post_render', function(){	
	    jQuery('.main .gform_wrapper, .sidebar .grid-x-wrapper').find('.gform_body .gform_fields').addClass("grid-x grid-padding-x");
	});
		
	var star = '<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="star" width="25" height="25" class="svg-inline--fa fa-star fa-w-18" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path fill="currentColor" d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path></svg>';
		
	jQuery('.stars').html( `${star} ${star} ${star} ${star} ${star}` );
	
	// This fixes the flash bug on the navigation
	jQuery('.lower-bar').removeClass('wait-js');
	jQuery('.sticky-wrapper-navigation').removeClass('wait-js');	
	
	jQuery('.menu .menu-item a').wrapInner('<span class="nav-text"></span>');
	
	
	jQuery('<div class="svg-quote"><svg id="Component_2_1" data-name="Component 2 – 1" xmlns="http://www.w3.org/2000/svg" width="47" height="47" viewBox="0 0 47 47"><text id="_" data-name="“" transform="translate(0 108)" font-size="140" font-family="Helvetica"><tspan x="0" y="0">“</tspan></text></svg></div>').prependTo('blockquote');
	
	jQuery('.button:not(.play)').wrapInner("<span class='button-text'></span>");
	jQuery('a.with-arrow').wrapInner("<span class='button-text'></span>");

	jQuery('.child-page-section li a').wrapInner("<span class='link-text'></span>");
	
	jQuery('.full-width-green').addClass('full-width-gold').removeClass('full-width-green');
	jQuery('.full-width-blue').addClass('full-width-gray').removeClass('full-width-blue');
	jQuery('.full-width-yellow').addClass('full-width-gold-second').removeClass('full-width-yellow'); 

	// ********** Creating active state in mobile tile links ********** //
	
	var currentUrl = window.location.href;
	// console.log(currentUrl);
	
	jQuery(".lower-bar .mobile-tile").each(function() {
		var tileLink = jQuery(this).find("a").attr("href");
		//console.log(tileLink);
		//console.log(currentUrl.includes(tileLink));
		if(currentUrl.includes(tileLink)) {
			jQuery(this).addClass("is-active");
		}
		
	})

}

var currentTransition = "",
currentPosition = "";

function initOffCanvasSwitcher() {

	jQuery(window).on("load",function(e){
		var newSize = Foundation.MediaQuery.current;		
		setOffcanvasPosition(newSize);		
	});	
		
	jQuery(window).on('changed.zf.mediaquery', function(event, newSize, oldSize) {
		// newSize is the name of the now-current breakpoint, oldSize is the previous breakpoint		 
		setOffcanvasPosition(newSize);		  
	});
	
	function setOffcanvasPosition(newSize) {		
		var mobileOffcanvas = jQuery('#off-canvas').data("mobile").split(" "),
		tabletOffcanvas = jQuery('#off-canvas').data("tablet").split(" "),
		offCanvas = jQuery('#off-canvas');
				
		if(newSize == 'xmedium' || newSize == 'medium'){		
			offCanvas.removeClass("position-"+mobileOffcanvas[0]).addClass("position-"+tabletOffcanvas[0]);
			offCanvas.removeClass("is-transition-"+mobileOffcanvas[1]).attr("data-transition", tabletOffcanvas[1]).addClass("is-transition-"+tabletOffcanvas[1]);			
			currentPosition = tabletOffcanvas[0];	
			currentTransition = tabletOffcanvas[1];					
		} 
		
		if(newSize == 'smedium' || newSize == 'small' || newSize == 'xsmall'){		
			offCanvas.removeClass("position-"+tabletOffcanvas[0]).addClass("position-"+mobileOffcanvas[0]);	
			offCanvas.removeClass("is-transition-"+tabletOffcanvas[1]).attr("data-transition", mobileOffcanvas[1]).addClass("is-transition-"+mobileOffcanvas[1]);			
			currentPosition	 = mobileOffcanvas[0];
			currentTransition = mobileOffcanvas[1];					
		}  
	}
		
	// ADDS class name to the body tag to disable scrolling when the offcanvas menu is open and adding transition and positioning class names
	jQuery('#off-canvas').on('opened.zf.offCanvas', function () {
        jQuery("body").addClass('offCanvasOpen');
		var navFixedState = Foundation.MediaQuery.is('xmedium down'),		
		hasIsAnchored = jQuery('.sticky-wrapper-navigation').hasClass('is-anchored');
		
        if(navFixedState && hasIsAnchored ){ jQuery('.sticky-wrapper-navigation').removeClass('is-anchored').addClass('is-stuck');}    
	
		jQuery(".hamburger").addClass("is-active");             
        jQuery('.off-canvas-content').removeClass('is-opened is-open-left has-position-left has-transition-push has-transition-overlap').addClass('is-opened is-open-'+currentPosition+' has-position-'+currentPosition+' has-transition-'+currentTransition);   		
    });
   
    jQuery('#off-canvas').on('close.zf.offCanvas', function () {
	    // Look for .hamburger
		jQuery(".hamburger").removeClass("is-active");
        jQuery("body").removeClass('offCanvasOpen');
        jQuery('.off-canvas-content').removeClass('is-opened is-open-'+currentPosition+' has-position-'+currentPosition);  
    });
}

function initGravityFormsStyles() {	
	
	initGformValidationJs();	
		
	jQuery(document).on('gform_post_render', function(){	  	
	   	jQuery('.gform_wrapper input, .gform_wrapper textarea').each(function( index ) {
		  var theFields = jQuery(this).val();
		   	if(theFields){	 
			   	jQuery(this).closest('.ginput_container').addClass('typing validated');
			   	jQuery(this).closest('.ginput_container').siblings('.gfield_label').addClass('highlight');
		   	}
		   	initGformValidationJs();		  
		})   	
	});	
}

function initGformValidationJs() {
		
	jQuery('.gform_wrapper input, .gform_wrapper textarea').focus(function() {
		jQuery(this).closest('.ginput_container').addClass('typing');
		jQuery(this).closest('.ginput_container').siblings('label.gfield_label').addClass('highlight');
		//jQuery(this).closest('.gfield_description.validation_message').css("display","none");
	})
	
	//When the user clicks out of a field
	jQuery('.gform_wrapper input, .gform_wrapper textarea').blur(function() {
		//The typing class is removed
		var textValue= jQuery(this).val();
		
		if(textValue != "") {
			jQuery(this).closest('.ginput_container').addClass('validated');
			jQuery(this).closest('.ginput_container').siblings('label.gfield_label').addClass('highlight');				 
		 }  else {
			jQuery(this).closest('.ginput_container').removeClass('typing');
			jQuery(this).closest('.ginput_container').removeClass('validated');	
			jQuery(this).closest('.ginput_container').siblings('label.gfield_label').removeClass('highlight');
		 }				
	})	

}

function initGalleries(){
	jQuery('.imgGalItem').click(function(event) {
			
		var selector = jQuery(this),
			link = selector.attr('data-link'),
			rel  = selector.attr('rel'),
			height = selector.attr('height'),
			width = selector.attr('width'),
			counts = selector.attr('data-groups'),			
			newContent = '<a href="'+link+'" rel="galSlideCell'+rel+'" data-fancybox="group'+counts+'" data-caption="*Individual Results May Vary"><img src="'+link+'" height="+height+" width="+width+"></a>',
			containerHeight = jQuery(".galSlideCell"+rel+" .main-gal-img a").height();		
		
		jQuery(".photoGallery"+rel).removeClass("is-active");
		selector.addClass("is-active");		
			
		jQuery(".galSlideCell"+rel+" .main-gal-img").stop().css({'opacity':'0' , 'height':containerHeight+'px'}).html(function () {				
		 		return newContent;
		    }).animate({
		        opacity: 1
		    },500);	
		    
		setTimeout(function(){jQuery(".galSlideCell"+rel+" .main-gal-img").css('height','auto'); }, 500); 		
		event.preventDefault();	
		return false;
	});	

	jQuery('select#mobile-sorting').on('change', function() {
	  window.location.replace(this.value);
	});
	
}

function initMobileExpandr() {
	jQuery('.mobileExpand').each( function () {
		var plusIcon = '<svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="plus-circle" class="svg-inline--fa fa-plus-circle fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="#ffffff" d="M384 250v12c0 6.6-5.4 12-12 12h-98v98c0 6.6-5.4 12-12 12h-12c-6.6 0-12-5.4-12-12v-98h-98c-6.6 0-12-5.4-12-12v-12c0-6.6 5.4-12 12-12h98v-98c0-6.6 5.4-12 12-12h12c6.6 0 12 5.4 12 12v98h98c6.6 0 12 5.4 12 12zm120 6c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-32 0c0-119.9-97.3-216-216-216-119.9 0-216 97.3-216 216 0 119.9 97.3 216 216 216 119.9 0 216-97.3 216-216z"></path></svg>';
		
		var minusIcon = '<svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="minus-circle" class="svg-inline--fa fa-minus-circle fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="white" d="M140 274c-6.6 0-12-5.4-12-12v-12c0-6.6 5.4-12 12-12h232c6.6 0 12 5.4 12 12v12c0 6.6-5.4 12-12 12H140zm364-18c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-32 0c0-119.9-97.3-216-216-216-119.9 0-216 97.3-216 216 0 119.9 97.3 216 216 216 119.9 0 216-97.3 216-216z"></path></svg>';
		
		var arrowIcon = '<svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="arrow-circle-right" class="svg-inline--fa fa-arrow-circle-right fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="#DFBB7D" d="M8 256c0 137 111 248 248 248s248-111 248-248S393 8 256 8 8 119 8 256zM256 40c118.7 0 216 96.1 216 216 0 118.7-96.1 216-216 216-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216zm12.5 92.5l115.1 115c4.7 4.7 4.7 12.3 0 17l-115.1 115c-4.7 4.7-12.3 4.7-17 0l-6.9-6.9c-4.7-4.7-4.7-12.5.2-17.1l85.6-82.5H140c-6.6 0-12-5.4-12-12v-10c0-6.6 5.4-12 12-12h190.3l-85.6-82.5c-4.8-4.7-4.9-12.4-.2-17.1l6.9-6.9c4.8-4.7 12.4-4.7 17.1 0z"></path></svg>'
		
		// if(jQuery(this).closest('.cell').hasClass('procedure')) {
		// 	var expandTar = jQuery(this),
		// 	ehmax = '',
		// 	expandTarBtn = `<a class="expandBtn"><span class="showMe">TAP TO READ MORE${arrowIcon}</span><span class="hideMe">TAP TO COLLAPSE ${minusIcon}</span></a>`;
		// }
		// else if(jQuery(this).closest('.grid-container').hasClass('geo-footer')) {
		// 	var expandTar = jQuery(this),
		// 	ehmax = '',
		// 	expandTarBtn = `<a class="expandBtn"><span class="showMe">TAP TO READ MORE${arrowIcon}</span><span class="hideMe">TAP TO COLLAPSE ${minusIcon}</span></a>`;
		// }
		// else {
			var expandTar = jQuery(this),
			ehmax = '',
			expandTarBtn = `<a class="expandBtn"><span class="showMe">TAP TO EXPAND ${plusIcon}</span><span class="hideMe">TAP TO COLLAPSE ${minusIcon}</span></a>`;
		// }
		
		expandTar.wrapInner('<div class="expandrContent"></div>');
		expandTar.append(expandTarBtn);
	
		jQuery(this).find('.expandrContent').each( function(){
			ehmax = jQuery(this).parent().data('eh-max');
			jQuery(this).find('.expandrContent').css('max-height', ehmax);		
			jQuery(this).css('max-height', ehmax );
		});
		
		jQuery(this).find('.expandBtn').on('click', function(){
			jQuery(this).find('.rotateMe').toggleClass('none down');
			jQuery(this).find('span').toggleClass('showMe hideMe');
			jQuery(this).parent().find('.expandrContent').toggleClass('expanded');
			jQuery(this).closest('.cell-background').toggleClass('expanded');
			jQuery(this).closest('.mobileExpand').toggleClass('expanded');
			jQuery(this).toggleClass('expanded');	
		});
	})
}

function initParallax(){	
    jQuery(window).on('load scroll', function () {
		var scrolled =  jQuery(this).scrollTop(),
			xpos = 50,
			ypos = 50,
			bgsize = 'cover',
			scrollBottom = jQuery(this).scrollTop() + jQuery(this).height();      	
    	
    	jQuery('.tagline').each(function(){  
	    	var selectors = jQuery(this);
	    	var theBottom = selectors.position().top + selectors.outerHeight(true);	
	    	if(scrolled <= theBottom) {
	    		jQuery('.tagline').css({
	        		'transform': 'translate3d(0, ' + -(scrolled * 0.25) + 'px, 0)', 
					// 'opacity': 1 - scrolled / 400 // fade out at 400px from top
	    		}); 
	    	}    	  
     	});
        	
        /* Uses the default class name 'banner-parallax' on the frontpage banner, use data-speed="0.2"(20% scroll rate use decimals)  */                
        jQuery('.banner-parallax').each(function(){ 
	        	var speed = jQuery(this).attr('data-speed');
	        	var position = jQuery(this);
	        	var bottom = position.position().top + position.outerHeight(true);	  		        	
	        
	        	if(scrolled <= bottom) {	
	        		jQuery(this).css('transform', 'translate3d(0, ' + (scrolled  * speed) + 'px, 0)');
	        	}        	     	
        });
        
      
       	/* Use the class name 'parallax', use data-speed="0.2"(20% scroll rate use decimals)  */
	   	jQuery('.parallax').each(function(){ 
        	var speed = jQuery(this).attr('data-speed'),
        		xposval = jQuery(this).attr('data-xpos'),
        		yposval = jQuery(this).attr('data-ypos'),
        		bgsizeval = jQuery(this).attr('data-bg-size'),
        		parent = jQuery(this).parent(),
        		position = parent.position(),
        		bottom = parent.position().top + parent.outerHeight(true);
			if (xposval) {
	        	xpos = xposval;
        	}
        	if (yposval){
	        	ypos = yposval;
        	} 
        	if (bgsizeval){
	        	bgsize = bgsizeval;
        	}
        	if(!speed){ speed = 0.15; }
			if(scrolled <= bottom && scrollBottom > position.top ) {        		        	
        		jQuery(this).css({
	        		'background-position': xpos + '% calc(' + ypos +'% + ' + ((scrolled  - position.top ) * speed) + 'px)',
	        		'background-size': bgsize
	        	});         		
        	}	        	      	
        });        
    });	    
}


function initNavigation() {
	jQuery('.sticky-wrapper-navigation').on('sticky.zf.stuckto:top', function(){
	  	jQuery(this).addClass('shrink');
	}).on('sticky.zf.unstuckfrom:top', function(){
	  	jQuery(this).removeClass('shrink');
	})	
}



function initHellobar(){
	var helloBarContainer = jQuery('#hello-bar-main');
	if(helloBarContainer.length){
		jQuery('#hello-bar-close-btn').click(function() {
		 helloBarContainer.animate({
		      maxHeight: '0',
		      opacity: '0',
		      padding: '0',
		    });
		});	
	}
}

var navigator;
var DocumentTouch;
// VIDEO FOR FRONT PAGE
function initHpVideo() {		
			var isTouchDevice = /Windows Phone/.test(navigator.userAgent) || ('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch;
		
	jQuery('.banner-wrapper .video').each(function() {
		var holder = jQuery(this);
		var video = holder.find('video');
		var isDesktop = jQuery(document).width() < 1025 ? true : false; 
		
		if (isTouchDevice && isDesktop) {
			video.remove();
			jQuery(".banner-wrapper .video").addClass("mobile");
			jQuery(".banner-wrapper .video").removeClass("desktop");
		} else {
			jQuery(".banner-wrapper .video").addClass("desktop");
		}
	});
}

//	Animations v1.1, Joe Mottershaw (hellojd)
//	https://github.com/hellojd/animations / https://github.com/Sananes/animations

//	==================================================

//	Visible, Sam Sehnert, samatdf, TeamDF
//	https://github.com/teamdf/jquery-visible/
//	==================================================

	(function($){
		
		$.fn.visible = function(partial,hidden,direction) {
			var $t				= jQuery(this).eq(0),
				t				= $t.get(0),
				$w				= jQuery(window),
				viewTop			= $w.scrollTop(),
				viewBottom		= viewTop + $w.height(),
				viewLeft		= $w.scrollLeft(),
				viewRight		= viewLeft + $w.width(),
				_top			= $t.offset().top,
				_bottom			= _top + $t.height(),
				_left			= $t.offset().left,
				_right			= _left + $t.width(),
				compareTop		= partial === true ? _bottom : _top,
				compareBottom	= partial === true ? _top : _bottom,
				compareLeft		= partial === true ? _right : _left,
				compareRight	= partial === true ? _left : _right,
				clientSize		= hidden === true ? t.offsetWidth * t.offsetHeight : true;
				direction		= (direction) ? direction : 'both';

			if(direction === 'both')
				return !!clientSize && ((compareBottom <= viewBottom) && (compareTop >= viewTop)) && ((compareRight <= viewRight) && (compareLeft >= viewLeft));
			else if(direction === 'vertical')
				return !!clientSize && ((compareBottom <= viewBottom) && (compareTop >= viewTop));
			else if(direction === 'horizontal')
				return !!clientSize && ((compareRight <= viewRight) && (compareLeft >= viewLeft));
		};
		

		$.fn.fireAnimations = function(options) {
			function animate() {
				if (jQuery(window).width() >= 960) {
					jQuery('.animate').each(function(i, elem) {
							elem = jQuery(elem);
							var	type = jQuery(this).attr('data-anim-type'),
							delay = jQuery(this).attr('data-anim-delay');

						if (elem.visible(true)) {
							setTimeout(function() {
								elem.addClass(type);
							}, delay);
						} 
					});
				} else {
					jQuery('.animate').each(function(i, elem) {
							elem = jQuery(elem);
						var	type = jQuery(this).attr('data-anim-type'),
							delay = jQuery(this).attr('data-anim-delay');

							setTimeout(function() {
								elem.addClass(type);
							}, delay);
					});
				}
			}

			jQuery(document).ready(function() {
				jQuery('html').removeClass('no-js').addClass('js');

				animate();
			});

			jQuery(window).scroll(function() {
				animate();

				if (jQuery(window).scrollTop() + jQuery(window).height() == jQuery(document).height()) {
					animate();
				}
			});
		};

		jQuery('.animate').fireAnimations();

	})(jQuery);
		
	var	triggerClasses = 'flash strobe shake bounce tada wave spin pullback wobble pulse pulsate heartbeat panic explode';
		
	var	classesArray = [];
		classesArray = triggerClasses.split(' ');

	var	classAmount = classesArray.length;
	var type;
	
	function randomClass() {
		var	random = Math.ceil(Math.random() * classAmount);

		type = classesArray[random];

		return type;
	}

	function triggerOnce(target, type) {
		if (type == 'random') {
			type = randomClass();
		}

		jQuery(target).removeClass('trigger infinite ' + triggerClasses).addClass('trigger').addClass(type).one('webkitAnimationEnd oAnimationEnd MSAnimationEnd animationend', function() {
			jQuery(this).removeClass('trigger infinite ' + triggerClasses);
		});
	}

	function triggerInfinite(target, type) {
		if (type == 'random') {
			type = randomClass();
		}

		jQuery(target).removeClass('trigger infinite ' + triggerClasses).addClass('trigger infinite').addClass(type).one('webkitAnimationEnd oAnimationEnd MSAnimationEnd animationend', function() {
			jQuery(this).removeClass('trigger infinite ' + triggerClasses);
		});
	}

/*	jQuery(window).resize(function() {
		jQuery('.animate').fireAnimations();
	});
*/

function initBrowserExposure() {
	


    var uaMatch = '', prefix = '';

    if (navigator.userAgent.match(/Windows/))
    {
      jQuery('html').addClass('windows');
    }
    else if (navigator.userAgent.match(/Mac OS X/))
    {
      jQuery('html').addClass('macOs');
    }
    else if (navigator.userAgent.match(/X11/))
    {
      jQuery('html').addClass('x11');
    }

	var supports = (function() {
    var d = document.documentElement,
        c = "ontouchstart" in window || navigator.msMaxTouchPoints;
    if (c) {
        d.className += " touch";
        return {
            touch: true
        }
    } else {
        d.className += " no-touch";
        return {
            touch: false
        }
    }
	})();

    // browser
    if (navigator.userAgent.match(/Chrome/))
    {
      uaMatch = ' Chrome/';
      prefix = 'chrome';
    }
    else if (navigator.userAgent.match(/Safari/))
    {
      uaMatch = ' Version/';
      prefix = 'safari';
    }
    else if (navigator.userAgent.match(/Firefox/))
    {
      uaMatch = ' Firefox/';
      prefix = 'firefox';
    }
    else if (navigator.userAgent.match(/MSIE/))
    {
      uaMatch = ' MSIE ';
      prefix = 'x-msie';
    }
    // add result preifx as browser class
    if (prefix)
    {
      jQuery('html').addClass(prefix);	   
    }

}

// Get IE or Edge browser version
var version = detectIE();

if (version === false) {
  jQuery('html').addClass('not-ie-edge');
} else if (version >= 12) {
   jQuery('html').addClass('edge edge-'+ version);
} else {
   jQuery('html').addClass('ie ie-'+ version);
}

// add details to debug result
//document.getElementById('details').innerHTML = window.navigator.userAgent;

/**
 * detect IE
 * returns version of IE or false, if browser is not Internet Explorer
 */
 
function detectIE() {
  var ua = window.navigator.userAgent;

  // Test values; Uncomment to check result …

  // IE 10
  // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';
  
  // IE 11
  // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';
  
  // Edge 12 (Spartan)
  // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';
  
  // Edge 13
  // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';

  var msie = ua.indexOf('MSIE ');
  if (msie > 0) {
    // IE 10 or older => return version number
    return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
  }

  var trident = ua.indexOf('Trident/');
  if (trident > 0) {
    // IE 11 => return version number
    var rv = ua.indexOf('rv:');
    return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
  }

  var edge = ua.indexOf('Edge/');
  if (edge > 0) {
    // Edge (IE 12+) => return version number
    return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
  }

  // other browser
  return false;
}

function initMenuStyle() {
	var menu = jQuery("li.move-left");
	var observer = new MutationObserver(function(mutations) {
	  mutations.forEach(function(mutation) {
		if (mutation.attributeName === "class") {
		  var attributeValue = jQuery(mutation.target).prop(mutation.attributeName);
		  if(attributeValue.includes('is-active')) {
			  jQuery('li.move-left').closest('.submenu').addClass('moving');
			  let parentMenuHeight = jQuery('li.move-left').closest('.submenu').outerHeight();
			  jQuery('li.move-left').find('.submenu').css('height', parentMenuHeight);
		  }
		  else {
			  jQuery('li.move-left').closest('.submenu').removeClass('moving');
			  jQuery('li.move-left').find('.submenu').css('height', 'auto');
		  }
		}
	  });
	});
	observer.observe(menu[0], {
	  attributes: true
	});
	
}

//Scripts needed for serving pages and front page

jQuery(document).ready(function($) {	
	initPreloaderScreen();
	initSliders();		
	initLogoSlider();
	jQuery(window).resize(function() {
		initLogoSlider();
	})
});

function initPreloaderScreen() {
	setTimeout(function(){
		jQuery('.home #loader').addClass('animated zoomOut');		
	}, 1000);
	setTimeout(function(){		
		jQuery('.home #loader-wrapper').fadeOut('slow');	
		jQuery('.home .off-canvas-wrapper').css('opacity', 1);
	}, 1550);
	initSubmenus();
}


function initSubmenus() {
	jQuery('.top-bar #menu-topnav-1').css('opacity',1);	
/*	setTimeout(function(){
		jQuery('.top-bar .fixedlogo').css('display','block').addClass('animated fadeInLeft');
	}, 800); */
}


function initSliders(){	
	/* https://swiperjs.com/get-started/  */
	
	var fpImagesSlider = jQuery('#fp-services-images');
	if(fpImagesSlider.length) {  
		var fpImage = new Swiper ('#fp-services-images' , {
			// Optional parameters
			direction: 'horizontal',
			loop: true,
			autoHeight: false,
			slidesPerView: 1,
			spaceBetween: 10,
			effect: 'fade',
			//init: 'false',
			// fadeEffect: {
			// 	crossFade: true
			// },
		})
	}
	
	var fpServicesSlider = jQuery('#fp-services-slider');
	if(fpServicesSlider.length) {  
		var fpService = new Swiper ('#fp-services-slider' , {
			// Optional parameters
			direction: 'horizontal',
			loop: true,
			autoHeight: false,
			slidesPerView: 1,
			spaceBetween: 10,
			effect: 'fade',
			//init: 'false',
			// fadeEffect: {
			// 	crossFade: true
			// },
			// If we need pagination
			pagination: {
			  el: '.swiper-pagination',
			  clickable: true,
			  type: 'bullets',
			},
		
			// Navigation arrows
			navigation: {
			  nextEl: '.swiper-button-next',
			  prevEl: '.swiper-button-prev',
			},
			on: {
				slideChange: function () {
				  let thisIndex = jQuery(this)[0].activeIndex;
				  fpImage.slideTo(thisIndex);
				},
			  }
		})
	}
	
	var fpResourcesImagesSlider = jQuery('#fp-resources-images');
	if(fpResourcesImagesSlider.length) {  
		var fpResourcesImages = new Swiper ('#fp-resources-images' , {
			// Optional parameters
			direction: 'horizontal',
			loop: true,
			autoHeight: false,
			slidesPerView: 1,
			spaceBetween: 10,
			effect: 'fade',
			//init: 'false',
			// fadeEffect: {
			// 	crossFade: true
			// },
		})
	}
	
	var fpResourcesSlider = jQuery('#fp-resources-slider');
	if(fpResourcesSlider.length) {  
		var fpResources = new Swiper ('#fp-resources-slider' , {
			// Optional parameters
			direction: 'horizontal',
			loop: true,
			autoHeight: false,
			slidesPerView: 1,
			spaceBetween: 10,
			effect: 'fade',
			//init: 'false',
			// fadeEffect: {
			// 	crossFade: true
			// },
			// If we need pagination
			pagination: {
			  el: '.swiper-pagination',
			  clickable: true,
			  type: 'bullets',
			},
		
			// Navigation arrows
			navigation: {
			  nextEl: '.swiper-button-next',
			  prevEl: '.swiper-button-prev',
			},
			on: {
				slideChange: function () {
				  let thisIndex = jQuery(this)[0].activeIndex;
				  fpResourcesImages.slideTo(thisIndex);
				},
			  }
		})
	}

	// var fpcarouselinner = jQuery('.fp-carousel-row-inner');
	// if(fpcarouselinner.length) {  
	//   var mySwiper = new Swiper ('.fp-carousel-row-inner' , {
	//     // Optional parameters
	//     direction: 'horizontal',
	//     loop: true,
	//     autoHeight: true,
	//     slidesPerView: 1,
	// 	spaceBetween: 10,
	// 
	//     // If we need pagination
	// 		pagination: {
	// 		  el: '.swiper-pagination',
	// 		  clickable: true,
	// 		  type: 'bullets',
	// 					
	// 		},
	// 	
	// 		// Navigation arrows
	// 		navigation: {
	// 		  nextEl: '.swiper-button-next',
	// 		  prevEl: '.swiper-button-prev',
	// 		},
	// 
	//     // And if we need scrollbar
	//   })
	// }
}	